import { Link } from "react-router-dom";

import { RegistrationButton } from "@components/index";
import BgImg from "@assets/images/layout-bg.png";
import LogoImg from "@assets/images/logo.svg";
import AwardImg from "@assets/images/award.png";

export const LeftSidebarNotAuth = () => (
  <div
    className="w-[560px] rounded-s-lg bg-left-top bg-no-repeat xxl:min-w-[560px]"
    style={{ backgroundImage: `url('${BgImg}')` }}
  >
    <div className="relative flex min-h-dvh flex-col justify-between rounded-s-lg bg-gradient-to-b from-[#283583B2] to-[#0B83CBB2] px-10 pb-16 pt-10">
      <Link to="/" className="flex h-24 shrink-0 items-start">
        <img
          src={LogoImg}
          alt="Logo"
          width={200}
          className="relative -left-6 -top-6"
        />
      </Link>
      <img
        src={AwardImg}
        alt="Award"
        width="96"
        height="96"
        className="absolute right-10 top-10"
      />
      <div>
        <p className="text-600 font-bold text-white-100">
          A specialist accountancy service for small businesses and the
          self-employed
        </p>
        <ul className="list-inside list-disc pt-2 font-light text-white-87 *:pt-2">
          <li>Uncomplicated and straightforward process</li>
          <li>Comprehensive service</li>
          <li>
            Providing outstanding service to our customers for over 35 years
          </li>
          <li>Serving over 2,000 clients throughout the U.K.</li>
          <li>
            Low cost monthly fee allows you to spread the cost over the year
          </li>
        </ul>
        <RegistrationButton />
      </div>
    </div>
  </div>
);
